// // pages/CurrentAffairsPage.jsx
// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import { motion } from "framer-motion";

// const CurrentAffairsPage = ({ type = "daily" }) => {
//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, []);

//   const [activeCategory, setActiveCategory] = useState("all");
//   const [activeMonth, setActiveMonth] = useState("march");

//   const pageTitle =
//     type === "daily" ? "Daily Current Affairs" : "Monthly Current Affairs";

//   const categories = [
//     { id: "all", name: "All Topics" },
//     { id: "polity", name: "Polity & Governance" },
//     { id: "economy", name: "Economy" },
//     { id: "international", name: "International Relations" },
//     { id: "environment", name: "Environment & Ecology" },
//     { id: "science", name: "Science & Technology" },
//     { id: "history", name: "History & Culture" },
//   ];

//   const months = [
//     { id: "march", name: "March 2025" },
//     { id: "february", name: "February 2025" },
//     { id: "january", name: "January 2025" },
//     { id: "december", name: "December 2024" },
//     { id: "november", name: "November 2024" },
//     { id: "october", name: "October 2024" },
//   ];

//   // Example daily current affairs
//   const dailyAffairs = [
//     {
//       id: 1,
//       date: "March 15, 2025",
//       title: "Indias New Climate Policy Initiative",
//       category: "environment",
//       summary:
//         "Government announces new policy to reduce carbon emissions by 45% by 2035, emphasizing renewable energy and sustainable development.",
//       image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRz21aqE7zL92xkoj-fUVcazOthVqbUpI2ecg&s",
//       prelims_relevance: true,
//       mains_relevance: true,
//     },
//     {
//       id: 2,
//       date: "March 15, 2025",
//       title: "Supreme Court Ruling on Electoral Bonds",
//       category: "polity",
//       summary:
//         "Supreme Court delivers landmark judgment on electoral bonds, emphasizing transparency in political funding.",
//       image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS7jxMzOkX75ZiKlFu-EvTCbbn1O3yZj44ZXQ&s",
//       prelims_relevance: true,
//       mains_relevance: true,
//     },
//     {
//       id: 3,
//       date: "March 14, 2025",
//       title: "New RBI Guidelines for Digital Banking",
//       category: "economy",
//       summary:
//         "RBI issues comprehensive guidelines for digital banking operations, focusing on security and financial inclusion.",
//       image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT9aHQG14iCil8wG3LRF25apzNX0yHk-jM0-Q&s",
//       prelims_relevance: true,
//       mains_relevance: false,
//     },
//     {
//       id: 4,
//       date: "March 14, 2025",
//       title: "India-EU Trade Agreement",
//       category: "international",
//       summary:
//         "India and EU finalize comprehensive trade agreement after six years of negotiations, covering goods, services and investments.",
//       image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTesR6Mn1bxVGw8gdrjjb7VBlCdV1DeHijSfg&s",
//       prelims_relevance: true,
//       mains_relevance: true,
//     },
//     {
//       id: 5,
//       date: "March 13, 2025",
//       title: "Breakthrough in Quantum Computing Research",
//       category: "science",
//       summary:
//         "Indian scientists achieve significant breakthrough in quantum computing, developing new qubit stabilization technique.",
//       image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQODOLZLcQqq8g6AyWunmdebfaUUwGi_yBJmw&s",
//       prelims_relevance: true,
//       mains_relevance: false,
//     },
//     {
//       id: 6,
//       date: "March 13, 2025",
//       title: "New Archaeological Discoveries in Tamil Nadu",
//       category: "history",
//       summary:
//         "Archaeological Survey of India uncovers ancient Chola-era artifacts and structures in Tamil Nadu, dating back to 9th century CE.",
//       image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRT2zro_JmqFz_ENbJiebKfmHyaQCaP7eYD7w&s",
//       prelims_relevance: true,
//       mains_relevance: true,
//     },
//     {
//       id: 7,
//       date: "March 12, 2025",
//       title: "New National Water Policy",
//       category: "environment",
//       summary:
//         "Government releases draft National Water Policy 2025, focusing on conservation, management and equitable distribution.",
//       image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQp-Oc7t3kG9lf1XdtvoNGlWmmFkvSDxOfZyQ&s",
//       prelims_relevance: true,
//       mains_relevance: true,
//     },
//     {
//       id: 8,
//       date: "March 12, 2025",
//       title: "Indias Defense Production Strategy",
//       category: "international",
//       summary:
//         "Ministry of Defense unveils new strategy to boost indigenous defense production and reduce import dependency.",
//       image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRa5DHf3MAe8b6PvyNnbxGVnOUN58HEAXdX3w&s",
//       prelims_relevance: true,
//       mains_relevance: true,
//     },
//   ];

//   // Example monthly compilations
//   const monthlyCompilations = [
//     {
//       id: 1,
//       month: "march",
//       title: "March 2025 Current Affairs Compilation",
//       description:
//         "Comprehensive compilation of all significant events and developments from March 2025 with UPSC perspective.",
//       image:
//         "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcREAVWH5n0fn_YFbwjrHMsgAAuTV-bOOD-C5w&s",
//       pages: 85,
//       articles: 42,
//     },
//     {
//       id: 2,
//       month: "february",
//       title: "February 2025 Current Affairs Compilation",
//       description:
//         "Complete analysis of February 2025 events with subject-wise categorization and exam-relevant insights.",
//       image:
//         "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSjI2l_hvXPzl8T58RUUuAnGAg-inwtAJovIQ&s",
//       pages: 78,
//       articles: 38,
//     },
//     {
//       id: 3,
//       month: "january",
//       title: "January 2025 Current Affairs Compilation",
//       description:
//         "Detailed coverage of January 2025 current affairs with prelims MCQs and mains answer frameworks.",
//       image:
//         "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRdqEoTl0e3b-sJnXIwnv1HKTlb7ozM80zDVw&s",
//       pages: 92,
//       articles: 45,
//     },
//     {
//       id: 4,
//       month: "december",
//       title: "December 2024 Current Affairs Compilation",
//       description:
//         "Year-end special compilation covering all major events of December with annual review insights.",
//       image:
//         "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQosNCXvpNSK3Tu6rXNAJoByaZoPvP7HSm5lg&s",
//       pages: 105,
//       articles: 52,
//     },
//     {
//       id: 5,
//       month: "november",
//       title: "November 2024 Current Affairs Compilation",
//       description:
//         "Comprehensive analysis of November 2024 events with special focus on economic developments.",
//       image:
//         "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQUHQIm33fhvvzdlqDH0_8qAw2ItUcE1wJqSw&s",
//       pages: 82,
//       articles: 40,
//     },
//     {
//       id: 6,
//       month: "october",
//       title: "October 2024 Current Affairs Compilation",
//       description:
//         "In-depth coverage of October 2024 current affairs with subject-wise analysis and exam relevance.",
//       image:
//         "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSN0BNL6XpWMoyONcbWCaGwg2hWJpB-ttKQEg&s",
//       pages: 88,
//       articles: 43,
//     },
//   ];

//   // Filter daily affairs based on active category
//   const filteredDailyAffairs =
//     activeCategory === "all"
//       ? dailyAffairs
//       : dailyAffairs.filter((affair) => affair.category === activeCategory);

//   // Filter monthly compilations based on active month
//   const filteredMonthlyCompilations =
//     activeMonth === "all"
//       ? monthlyCompilations
//       : monthlyCompilations.filter(
//           (compilation) => compilation.month === activeMonth
//         );

//   return (
//     <div className="pt-20">
//       {/* Hero Section */}
//       <section className="relative bg-gradient-to-r from-gray-900 to-blue-800 text-white">
//         <div className="absolute inset-0">
//           <div className="absolute inset-0 bg-gray-900 opacity-90"></div>
//           <div className="absolute inset-0 bg-[url('https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRiqn5jXhC1CTq8isbIwTTte77VL0U7zhlBwQ&s')] opacity-10"></div>
//         </div>
//         <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
//           <div className="max-w-3xl">
//             <motion.h1
//               className="text-4xl md:text-5xl font-extrabold tracking-tight mb-6"
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5 }}
//             >
//               {pageTitle}
//             </motion.h1>
//             <motion.p
//               className="text-lg md:text-xl mb-8 text-gray-200"
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5, delay: 0.1 }}
//             >
//               {type === "daily"
//                 ? "Stay updated with daily analysis of current events and their relevance to UPSC examination."
//                 : "Access comprehensive monthly compilations of all important current affairs with UPSC perspective."}
//             </motion.p>
//             <motion.div
//               className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4"
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5, delay: 0.2 }}
//             >
//               <Link
//                 to="/register"
//                 className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-gray-900 bg-yellow-400 hover:bg-yellow-500 transition-colors duration-300 shadow-md"
//               >
//                 Subscribe Now
//               </Link>
//               <Link
//                 to={
//                   type === "daily"
//                     ? "/monthly-current-affairs"
//                     : "/daily-current-affairs"
//                 }
//                 className="inline-flex items-center justify-center px-6 py-3 border-2 border-white text-base font-medium rounded-md text-white hover:bg-white/10 transition-colors duration-300"
//               >
//                 {type === "daily"
//                   ? "View Monthly Compilations"
//                   : "View Daily Updates"}
//               </Link>
//             </motion.div>
//           </div>
//         </div>
//       </section>

//       {/* Daily Current Affairs Section */}
//       {type === "daily" && (
//         <>
//           {/* Category Filter */}
//           <section className="bg-white py-8 border-b">
//             <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//               <div className="flex flex-wrap justify-center">
//                 {categories.map((category) => (
//                   <button
//                     key={category.id}
//                     onClick={() => setActiveCategory(category.id)}
//                     className={`px-5 py-2 m-1 rounded-full text-sm font-medium transition-colors ${
//                       activeCategory === category.id
//                         ? "bg-gray-600 text-white"
//                         : "bg-gray-100 text-gray-700 hover:bg-gray-200"
//                     }`}
//                   >
//                     {category.name}
//                   </button>
//                 ))}
//               </div>
//             </div>
//           </section>

//           {/* Daily Affairs Grid */}
//           <section className="py-16 bg-gray-50">
//             <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//               <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
//                 {filteredDailyAffairs.map((affair, index) => (
//                   <motion.div
//                     key={affair.id}
//                     initial={{ opacity: 0, y: 20 }}
//                     animate={{ opacity: 1, y: 0 }}
//                     transition={{ duration: 0.5, delay: index * 0.1 }}
//                     className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300"
//                   >
//                     <div className="relative h-48">
//                       <img
//                         src={affair.image}
//                         alt={affair.title}
//                         className="w-full h-full object-cover"
//                       />
//                       <div className="absolute top-0 left-0 bg-gray-600 text-white px-3 py-1 text-xs font-medium">
//                         {affair.date}
//                       </div>
//                     </div>
//                     <div className="p-6">
//                       <div className="flex flex-wrap gap-2 mb-3">
//                         <span className="inline-block px-2 py-1 text-xs font-medium bg-gray-100 text-gray-800 rounded">
//                           {
//                             categories.find((c) => c.id === affair.category)
//                               ?.name
//                           }
//                         </span>
//                         {affair.prelims_relevance && (
//                           <span className="inline-block px-2 py-1 text-xs font-medium bg-green-100 text-green-800 rounded">
//                             Prelims
//                           </span>
//                         )}
//                         {affair.mains_relevance && (
//                           <span className="inline-block px-2 py-1 text-xs font-medium bg-blue-100 text-blue-800 rounded">
//                             Mains
//                           </span>
//                         )}
//                       </div>
//                       <h3 className="text-xl font-bold text-gray-900 mb-2">
//                         {affair.title}
//                       </h3>
//                       <p className="text-gray-600 mb-4 text-sm">
//                         {affair.summary}
//                       </p>
//                       <Link
//                         to={`/current-affairs/${affair.id}`}
//                         className="block w-full text-center py-2 px-4 border border-gray-600 rounded-md text-gray-600 font-medium hover:bg-gray-600 hover:text-white transition-colors duration-300"
//                       >
//                         Read Full Analysis
//                       </Link>
//                     </div>
//                   </motion.div>
//                 ))}
//               </div>

//               {/* Show message if no affairs in selected category */}
//               {filteredDailyAffairs.length === 0 && (
//                 <div className="text-center py-16">
//                   <h3 className="text-xl text-gray-600 mb-2">
//                     No current affairs available in this category today
//                   </h3>
//                   <p className="text-gray-500">
//                     Please check back later or explore other categories
//                   </p>
//                 </div>
//               )}
//             </div>
//           </section>
//         </>
//       )}

//       {/* Monthly Compilations Section */}
//       {type === "monthly" && (
//         <>
//           {/* Month Filter */}
//           <section className="bg-white py-8 border-b">
//             <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//               <div className="flex flex-wrap justify-center">
//                 {months.map((month) => (
//                   <button
//                     key={month.id}
//                     onClick={() => setActiveMonth(month.id)}
//                     className={`px-5 py-2 m-1 rounded-full text-sm font-medium transition-colors ${
//                       activeMonth === month.id
//                         ? "bg-gray-600 text-white"
//                         : "bg-gray-100 text-gray-700 hover:bg-gray-200"
//                     }`}
//                   >
//                     {month.name}
//                   </button>
//                 ))}
//               </div>
//             </div>
//           </section>

//           {/* Monthly Compilations Grid */}
//           <section className="py-16 bg-gray-50">
//             <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//               <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
//                 {filteredMonthlyCompilations.map((compilation, index) => (
//                   <motion.div
//                     key={compilation.id}
//                     initial={{ opacity: 0, y: 20 }}
//                     animate={{ opacity: 1, y: 0 }}
//                     transition={{ duration: 0.5, delay: index * 0.1 }}
//                     className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300"
//                   >
//                     <div className="relative h-48">
//                       <img
//                         src={compilation.image}
//                         alt={compilation.title}
//                         className="w-full h-full object-cover"
//                       />
//                     </div>
//                     <div className="p-6">
//                       <h3 className="text-xl font-bold text-gray-900 mb-2">
//                         {compilation.title}
//                       </h3>
//                       <p className="text-gray-600 mb-4 text-sm">
//                         {compilation.description}
//                       </p>
//                       <div className="flex justify-between items-center text-sm text-gray-500 mb-4">
//                         <span>{compilation.pages} pages</span>
//                         <span>{compilation.articles} articles</span>
//                       </div>
//                       <Link
//                         to={`/monthly-compilations/${compilation.id}`}
//                         className="block w-full text-center py-2 px-4 border border-gray-600 rounded-md text-gray-600 font-medium hover:bg-gray-600 hover:text-white transition-colors duration-300"
//                       >
//                         Download PDF
//                       </Link>
//                     </div>
//                   </motion.div>
//                 ))}
//               </div>
//             </div>
//           </section>
//         </>
//       )}

//       {/* Features Section */}
//       <section className="py-16 bg-white">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="text-center mb-16">
//             <motion.h2
//               className="text-3xl font-extrabold text-gray-900 sm:text-4xl"
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5 }}
//             >
//               {type === "daily"
//                 ? "Why Our Daily Current Affairs?"
//                 : "Why Our Monthly Compilations?"}
//             </motion.h2>
//             <motion.p
//               className="mt-4 max-w-2xl text-xl text-gray-600 mx-auto"
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5, delay: 0.1 }}
//             >
//               Save time and enhance your preparation with our expert analysis
//             </motion.p>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
//             <motion.div
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5 }}
//               className="bg-gray-50 p-6 rounded-lg text-center"
//             >
//               <div className="inline-flex items-center justify-center h-12 w-12 rounded-full bg-gray-100 text-gray-600 mb-4">
//                 <svg
//                   className="h-6 w-6"
//                   fill="none"
//                   viewBox="0 0 24 24"
//                   stroke="currentColor"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
//                   />
//                 </svg>
//               </div>
//               <h3 className="text-lg font-medium text-gray-900 mb-2">
//                 UPSC-Focused Analysis
//               </h3>
//               <p className="text-gray-600">
//                 Events analyzed specifically from UPSC exam perspective,
//                 highlighting Prelims and Mains relevance.
//               </p>
//             </motion.div>

//             <motion.div
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5, delay: 0.1 }}
//               className="bg-gray-50 p-6 rounded-lg text-center"
//             >
//               <div className="inline-flex items-center justify-center h-12 w-12 rounded-full bg-gray-100 text-gray-600 mb-4">
//                 <svg
//                   className="h-6 w-6"
//                   fill="none"
//                   viewBox="0 0 24 24"
//                   stroke="currentColor"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M13 10V3L4 14h7v7l9-11h-7z"
//                   />
//                 </svg>
//               </div>
//               <h3 className="text-lg font-medium text-gray-900 mb-2">
//                 Subject-wise Categorization
//               </h3>
//               <p className="text-gray-600">
//                 Content organized by subjects for targeted preparation and
//                 efficient revision.
//               </p>
//             </motion.div>

//             <motion.div
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5, delay: 0.2 }}
//               className="bg-gray-50 p-6 rounded-lg text-center"
//             >
//               <div className="inline-flex items-center justify-center h-12 w-12 rounded-full bg-gray-100 text-gray-600 mb-4">
//                 <svg
//                   className="h-6 w-6"
//                   fill="none"
//                   viewBox="0 0 24 24"
//                   stroke="currentColor"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
//                   />
//                 </svg>
//               </div>
//               <h3 className="text-lg font-medium text-gray-900 mb-2">
//                 Regular Updates
//               </h3>
//               <p className="text-gray-600">
//                 {type === "daily"
//                   ? "Daily updates to keep you informed with the latest developments"
//                   : "Comprehensive monthly compilations covering all important events"}
//               </p>
//             </motion.div>

//             <motion.div
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5, delay: 0.3 }}
//               className="bg-gray-50 p-6 rounded-lg text-center"
//             >
//               <div className="inline-flex items-center justify-center h-12 w-12 rounded-full bg-gray-100 text-gray-600 mb-4">
//                 <svg
//                   className="h-6 w-6"
//                   fill="none"
//                   viewBox="0 0 24 24"
//                   stroke="currentColor"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
//                   />
//                 </svg>
//               </div>
//               <h3 className="text-lg font-medium text-gray-900 mb-2">
//                 Expert Analysis
//               </h3>
//               <p className="text-gray-600">
//                 Content prepared by UPSC toppers and subject experts with
//                 exam-specific insights.
//               </p>
//             </motion.div>
//           </div>
//         </div>
//       </section>

//       {/* Subscription Section */}
//       <section className="py-16 bg-gray-50">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="text-center mb-16">
//             <motion.h2
//               className="text-3xl font-extrabold text-gray-900 sm:text-4xl"
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5 }}
//             >
//               Current Affairs Subscription Plans
//             </motion.h2>
//             <motion.p
//               className="mt-4 max-w-2xl text-xl text-gray-600 mx-auto"
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5, delay: 0.1 }}
//             >
//               Choose the plan that best suits your preparation needs
//             </motion.p>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
//             {/* Basic Plan */}
//             <motion.div
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5 }}
//               className="bg-white rounded-lg shadow-md overflow-hidden border border-gray-200"
//             >
//               <div className="p-8 text-center">
//                 <h3 className="text-2xl font-bold text-gray-900 mb-2">Basic</h3>
//                 <p className="text-gray-600 mb-6">Monthly compilations only</p>
//                 <div className="flex justify-center items-end mb-6">
//                   <span className="text-4xl font-extrabold text-gray-900">
//                     ₹2,999
//                   </span>
//                   <span className="text-gray-600 ml-2">/year</span>
//                 </div>
//                 <ul className="text-left space-y-4 mb-8">
//                   <li className="flex items-start">
//                     <svg
//                       className="h-5 w-5 text-green-500 mt-0.5"
//                       fill="none"
//                       viewBox="0 0 24 24"
//                       stroke="currentColor"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M5 13l4 4L19 7"
//                       />
//                     </svg>
//                     <span className="ml-3 text-gray-600">
//                       Monthly current affairs compilations
//                     </span>
//                   </li>
//                   <li className="flex items-start">
//                     <svg
//                       className="h-5 w-5 text-green-500 mt-0.5"
//                       fill="none"
//                       viewBox="0 0 24 24"
//                       stroke="currentColor"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M5 13l4 4L19 7"
//                       />
//                     </svg>
//                     <span className="ml-3 text-gray-600">
//                       Prelims & Mains relevance marked
//                     </span>
//                   </li>
//                   <li className="flex items-start">
//                     <svg
//                       className="h-5 w-5 text-green-500 mt-0.5"
//                       fill="none"
//                       viewBox="0 0 24 24"
//                       stroke="currentColor"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M5 13l4 4L19 7"
//                       />
//                     </svg>
//                     <span className="ml-3 text-gray-600">
//                       Downloadable PDF format
//                     </span>
//                   </li>
//                   <li className="flex items-start text-gray-400">
//                     <svg
//                       className="h-5 w-5 text-gray-400 mt-0.5"
//                       fill="none"
//                       viewBox="0 0 24 24"
//                       stroke="currentColor"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M6 18L18 6M6 6l12 12"
//                       />
//                     </svg>
//                     <span className="ml-3">Daily current affairs updates</span>
//                   </li>
//                   <li className="flex items-start text-gray-400">
//                     <svg
//                       className="h-5 w-5 text-gray-400 mt-0.5"
//                       fill="none"
//                       viewBox="0 0 24 24"
//                       stroke="currentColor"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M6 18L18 6M6 6l12 12"
//                       />
//                     </svg>
//                     <span className="ml-3">MCQs and practice questions</span>
//                   </li>
//                 </ul>
//                 <Link
//                   to="/register?plan=ca_basic"
//                   className="block w-full bg-gray-100 hover:bg-gray-200 text-gray-900 font-medium rounded-md py-3 px-4 transition-colors duration-300"
//                 >
//                   Subscribe Now
//                 </Link>
//               </div>
//             </motion.div>

//             {/* Standard Plan */}
//             <motion.div
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5, delay: 0.1 }}
//               className="bg-white rounded-lg shadow-lg overflow-hidden border-2 border-gray-500 relative transform scale-105 z-10"
//             >
//               <div className="absolute top-0 inset-x-0 flex justify-center">
//                 <span className="inline-block px-4 py-1 rounded-b-lg text-xs font-semibold tracking-wide uppercase bg-gray-600 text-white">
//                   Most Popular
//                 </span>
//               </div>
//               <div className="p-8 text-center pt-12">
//                 <h3 className="text-2xl font-bold text-gray-900 mb-2">
//                   Standard
//                 </h3>
//                 <p className="text-gray-600 mb-6">
//                   Daily updates + Monthly compilations
//                 </p>
//                 <div className="flex justify-center items-end mb-6">
//                   <span className="text-4xl font-extrabold text-gray-600">
//                     ₹4,999
//                   </span>
//                   <span className="text-gray-600 ml-2">/year</span>
//                 </div>
//                 <ul className="text-left space-y-4 mb-8">
//                   <li className="flex items-start">
//                     <svg
//                       className="h-5 w-5 text-green-500 mt-0.5"
//                       fill="none"
//                       viewBox="0 0 24 24"
//                       stroke="currentColor"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M5 13l4 4L19 7"
//                       />
//                     </svg>
//                     <span className="ml-3 text-gray-600">
//                       Daily current affairs updates
//                     </span>
//                   </li>
//                   <li className="flex items-start">
//                     <svg
//                       className="h-5 w-5 text-green-500 mt-0.5"
//                       fill="none"
//                       viewBox="0 0 24 24"
//                       stroke="currentColor"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M5 13l4 4L19 7"
//                       />
//                     </svg>
//                     <span className="ml-3 text-gray-600">
//                       Monthly current affairs compilations
//                     </span>
//                   </li>
//                   <li className="flex items-start">
//                     <svg
//                       className="h-5 w-5 text-green-500 mt-0.5"
//                       fill="none"
//                       viewBox="0 0 24 24"
//                       stroke="currentColor"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M5 13l4 4L19 7"
//                       />
//                     </svg>
//                     <span className="ml-3 text-gray-600">
//                       Subject-wise categorization
//                     </span>
//                   </li>
//                   <li className="flex items-start">
//                     <svg
//                       className="h-5 w-5 text-green-500 mt-0.5"
//                       fill="none"
//                       viewBox="0 0 24 24"
//                       stroke="currentColor"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M5 13l4 4L19 7"
//                       />
//                     </svg>
//                     <span className="ml-3 text-gray-600">
//                       Prelims & Mains relevance marked
//                     </span>
//                   </li>
//                   <li className="flex items-start text-gray-400">
//                     <svg
//                       className="h-5 w-5 text-gray-400 mt-0.5"
//                       fill="none"
//                       viewBox="0 0 24 24"
//                       stroke="currentColor"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M6 18L18 6M6 6l12 12"
//                       />
//                     </svg>
//                     <span className="ml-3">MCQs and practice questions</span>
//                   </li>
//                 </ul>
//                 <Link
//                   to="/register?plan=ca_standard"
//                   className="block w-full bg-gray-600 hover:bg-gray-700 text-white font-medium rounded-md py-3 px-4 transition-colors duration-300"
//                 >
//                   Subscribe Now
//                 </Link>
//               </div>
//             </motion.div>

//             {/* Premium Plan */}
//             <motion.div
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5, delay: 0.2 }}
//               className="bg-white rounded-lg shadow-md overflow-hidden border border-gray-200"
//             >
//               <div className="p-8 text-center">
//                 <h3 className="text-2xl font-bold text-gray-900 mb-2">
//                   Premium
//                 </h3>
//                 <p className="text-gray-600 mb-6">
//                   Complete package with practice questions
//                 </p>
//                 <div className="flex justify-center items-end mb-6">
//                   <span className="text-4xl font-extrabold text-gray-900">
//                     ₹6,999
//                   </span>
//                   <span className="text-gray-600 ml-2">/year</span>
//                 </div>
//                 <ul className="text-left space-y-4 mb-8">
//                   <li className="flex items-start">
//                     <svg
//                       className="h-5 w-5 text-green-500 mt-0.5"
//                       fill="none"
//                       viewBox="0 0 24 24"
//                       stroke="currentColor"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M5 13l4 4L19 7"
//                       />
//                     </svg>
//                     <span className="ml-3 text-gray-600">
//                       <strong>Everything</strong> in Standard plan
//                     </span>
//                   </li>
//                   <li className="flex items-start">
//                     <svg
//                       className="h-5 w-5 text-green-500 mt-0.5"
//                       fill="none"
//                       viewBox="0 0 24 24"
//                       stroke="currentColor"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M5 13l4 4L19 7"
//                       />
//                     </svg>
//                     <span className="ml-3 text-gray-600">
//                       Daily MCQs based on current affairs
//                     </span>
//                   </li>
//                   <li className="flex items-start">
//                     <svg
//                       className="h-5 w-5 text-green-500 mt-0.5"
//                       fill="none"
//                       viewBox="0 0 24 24"
//                       stroke="currentColor"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M5 13l4 4L19 7"
//                       />
//                     </svg>
//                     <span className="ml-3 text-gray-600">
//                       Mains answer writing frameworks
//                     </span>
//                   </li>
//                   <li className="flex items-start">
//                     <svg
//                       className="h-5 w-5 text-green-500 mt-0.5"
//                       fill="none"
//                       viewBox="0 0 24 24"
//                       stroke="currentColor"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M5 13l4 4L19 7"
//                       />
//                     </svg>
//                     <span className="ml-3 text-gray-600">
//                       Monthly current affairs webinars
//                     </span>
//                   </li>
//                   <li className="flex items-start">
//                     <svg
//                       className="h-5 w-5 text-green-500 mt-0.5"
//                       fill="none"
//                       viewBox="0 0 24 24"
//                       stroke="currentColor"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M5 13l4 4L19 7"
//                       />
//                     </svg>
//                     <span className="ml-3 text-gray-600">
//                       Quarterly revision notes
//                     </span>
//                   </li>
//                 </ul>
//                 <Link
//                   to="/register?plan=ca_premium"
//                   className="block w-full bg-gray-800 hover:bg-black text-white font-medium rounded-md py-3 px-4 transition-colors duration-300"
//                 >
//                   Subscribe Now
//                 </Link>
//               </div>
//             </motion.div>
//           </div>
//         </div>
//       </section>

//       {/* Testimonials */}
//       <section className="py-16 bg-white">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="text-center mb-16">
//             <motion.h2
//               className="text-3xl font-extrabold text-gray-900 sm:text-4xl"
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5 }}
//             >
//               What Our Subscribers Say
//             </motion.h2>
//             <motion.p
//               className="mt-4 max-w-2xl text-xl text-gray-600 mx-auto"
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5, delay: 0.1 }}
//             >
//               Hear from students who improved their current affairs preparation
//             </motion.p>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
//             <motion.div
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5 }}
//               className="bg-gray-50 p-6 rounded-lg border border-gray-200 shadow-md"
//             >
//               <p className="italic text-gray-600 mb-6">
//                 "The daily current affairs analysis saved me hours of newspaper
//                 reading. The subject-wise categorization and exam relevance
//                 markers were extremely helpful for focused preparation."
//               </p>
//               <div className="flex items-center">
//                 <div className="mr-4 h-12 w-12 rounded-full overflow-hidden border-2 border-gray-500">
//                   <img
//                     src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSDjtNi1m_f5OuxG9GcNMqa9i4F2sq_dVREdA&s"
//                     alt="Sneha Gupta"
//                     className="h-full w-full object-cover"
//                   />
//                 </div>
//                 <div>
//                   <h3 className="font-bold text-lg text-gray-900">
//                     Sneha Gupta
//                   </h3>
//                   <p className="text-gray-600 font-medium">AIR 89, CSE 2023</p>
//                 </div>
//               </div>
//             </motion.div>

//             <motion.div
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5, delay: 0.1 }}
//               className="bg-gray-50 p-6 rounded-lg border border-gray-200 shadow-md"
//             >
//               <p className="italic text-gray-600 mb-6">
//                 "Monthly compilations were perfect for revision before the exam.
//                 The quality of analysis and presentation of complex issues in
//                 simple language distinguished it from other sources."
//               </p>
//               <div className="flex items-center">
//                 <div className="mr-4 h-12 w-12 rounded-full overflow-hidden border-2 border-gray-500">
//                   <img
//                     src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTyBOAHtlqzaow5_rlz81tF3SwDxw4m5bYPzQ&s"
//                     alt="Vikram Singh"
//                     className="h-full w-full object-cover"
//                   />
//                 </div>
//                 <div>
//                   <h3 className="font-bold text-lg text-gray-900">
//                     Vikram Singh
//                   </h3>
//                   <p className="text-gray-600 font-medium">AIR 156, CSE 2022</p>
//                 </div>
//               </div>
//             </motion.div>

//             <motion.div
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5, delay: 0.2 }}
//               className="bg-gray-50 p-6 rounded-lg border border-gray-200 shadow-md"
//             >
//               <p className="italic text-gray-600 mb-6">
//                 "The MCQs and answer writing frameworks in the Premium plan
//                 significantly improved my performance. The current affairs
//                 webinars provided deeper insights into complex topics."
//               </p>
//               <div className="flex items-center">
//                 <div className="mr-4 h-12 w-12 rounded-full overflow-hidden border-2 border-gray-500">
//                   <img
//                     src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSDjtNi1m_f5OuxG9GcNMqa9i4F2sq_dVREdA&s"
//                     alt="Arjun Kapoor"
//                     className="h-full w-full object-cover"
//                   />
//                 </div>
//                 <div>
//                   <h3 className="font-bold text-lg text-gray-900">
//                     Arjun Kapoor
//                   </h3>
//                   <p className="text-gray-600 font-medium">AIR 124, CSE 2023</p>
//                 </div>
//               </div>
//             </motion.div>
//           </div>
//         </div>
//       </section>

//       {/* Call to Action */}
//       <section className="py-16 bg-gradient-to-r from-gray-900 to-blue-800 text-white">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="max-w-3xl mx-auto text-center">
//             <motion.h2
//               className="text-3xl font-extrabold mb-6"
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5 }}
//             >
//               Stay Ahead with Our Current Affairs
//             </motion.h2>
//             <motion.p
//               className="text-lg text-gray-200 mb-8"
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5, delay: 0.1 }}
//             >
//               Don't let current affairs become your weak point. Subscribe today
//               and transform your UPSC preparation.
//             </motion.p>
//             <motion.div
//               className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4"
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5, delay: 0.2 }}
//             >
//               <Link
//                 to="/register"
//                 className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-gray-900 bg-yellow-400 hover:bg-yellow-500 transition-colors duration-300 shadow-md"
//               >
//                 Subscribe Now
//               </Link>
//               <Link
//                 to="/contact"
//                 className="inline-flex items-center justify-center px-6 py-3 border-2 border-white text-base font-medium rounded-md text-white hover:bg-white/10 transition-colors duration-300"
//               >
//                 Contact Us
//               </Link>
//             </motion.div>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default CurrentAffairsPage;

import React, { useEffect, useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useCurrentAffairs } from "../context/CurrentAffairsContext";
import Spinner from "../components/common/Spinner";
import ErrorAlert from "../components/common/ErrorAlert";
import { formatDate } from "../utils/dateUtils";
import Pagination from "../components/common/Pagination";

const CurrentAffairsPage = ({ type = "daily" }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const categoryParam = searchParams.get("category");
  const monthParam = searchParams.get("month");
  const yearParam = searchParams.get("year");
  const pageParam = searchParams.get("page");

  const {
    dailyAffairs,
    monthlyCompilations,
    loading,
    error,
    filters,
    pagination,
    fetchDailyAffairs,
    fetchMonthlyCompilations,
    setFilters,
  } = useCurrentAffairs();

  const [activeCategory, setActiveCategory] = useState(categoryParam || "all");
  const [activeMonth, setActiveMonth] = useState(monthParam || "all");
  const [activeYear, setActiveYear] = useState(
    yearParam || new Date().getFullYear()
  );
  const [currentPage, setCurrentPage] = useState(parseInt(pageParam) || 1);

  useEffect(() => {
    window.scrollTo(0, 0);

    if (type === "daily") {
      fetchDailyAffairs(activeCategory, currentPage);
    } else {
      fetchMonthlyCompilations(activeMonth, activeYear, currentPage);
    }
  }, [
    type,
    activeCategory,
    activeMonth,
    activeYear,
    currentPage,
    fetchDailyAffairs,
    fetchMonthlyCompilations,
  ]);

  // Update URL with filters
  useEffect(() => {
    const params = new URLSearchParams();

    if (type === "daily" && activeCategory !== "all") {
      params.set("category", activeCategory);
    }

    if (type === "monthly") {
      if (activeMonth !== "all") {
        params.set("month", activeMonth);
      }
      params.set("year", activeYear);
    }

    if (currentPage > 1) {
      params.set("page", currentPage);
    }

    // Update URL without reloading
    const newUrl = params.toString()
      ? `/${
          type === "daily" ? "daily-current-affairs" : "monthly-current-affairs"
        }?${params.toString()}`
      : `/${
          type === "daily" ? "daily-current-affairs" : "monthly-current-affairs"
        }`;

    navigate(newUrl, { replace: true });
  }, [type, activeCategory, activeMonth, activeYear, currentPage, navigate]);

  const handleCategoryChange = (category) => {
    setActiveCategory(category);
    setCurrentPage(1);
  };

  const handleMonthChange = (month) => {
    setActiveMonth(month);
    setCurrentPage(1);
  };

  const handleYearChange = (year) => {
    setActiveYear(year);
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    window.scrollTo(0, 0);
  };

  const pageTitle =
    type === "daily" ? "Daily Current Affairs" : "Monthly Current Affairs";

  const categories = [
    { id: "all", name: "All Topics" },
    { id: "polity", name: "Polity & Governance" },
    { id: "economy", name: "Economy" },
    { id: "international", name: "International Relations" },
    { id: "environment", name: "Environment & Ecology" },
    { id: "science", name: "Science & Technology" },
    { id: "history", name: "History & Culture" },
  ];

  // Generate dynamic months for the current year and past years
  const generateMonths = () => {
    const months = [
      { id: "all", name: "All Months" },
      { id: "january", name: "January" },
      { id: "february", name: "February" },
      { id: "march", name: "March" },
      { id: "april", name: "April" },
      { id: "may", name: "May" },
      { id: "june", name: "June" },
      { id: "july", name: "July" },
      { id: "august", name: "August" },
      { id: "september", name: "September" },
      { id: "october", name: "October" },
      { id: "november", name: "November" },
      { id: "december", name: "December" },
    ];

    // If the current month is after January, only show months up to the current one
    if (activeYear === new Date().getFullYear()) {
      const currentMonth = new Date().getMonth(); // 0-based index (0 = January)
      return [months[0], ...months.slice(1, currentMonth + 2)];
    }

    return months;
  };

  // Generate years (current year and 2 years back)
  const generateYears = () => {
    const currentYear = new Date().getFullYear();
    const years = [];

    for (let i = 0; i < 3; i++) {
      years.push(currentYear - i);
    }

    return years;
  };

  const months = generateMonths();
  const years = generateYears();

  return (
    <div className="pt-20">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-r from-gray-900 to-blue-800 text-white">
        <div className="absolute inset-0">
          <div className="absolute inset-0 bg-gray-900 opacity-90"></div>
          <div className="absolute inset-0 bg-[url('https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRiqn5jXhC1CTq8isbIwTTte77VL0U7zhlBwQ&s')] opacity-10"></div>
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
          <div className="max-w-3xl">
            <motion.h1
              className="text-4xl md:text-5xl font-extrabold tracking-tight mb-6"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              {pageTitle}
            </motion.h1>
            <motion.p
              className="text-lg md:text-xl mb-8 text-gray-200"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
            >
              {type === "daily"
                ? "Stay updated with daily analysis of current events and their relevance to UPSC examination."
                : "Access comprehensive monthly compilations of all important current affairs with UPSC perspective."}
            </motion.p>
            <motion.div
              className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              <Link
                to="/register"
                className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-gray-900 bg-yellow-400 hover:bg-yellow-500 transition-colors duration-300 shadow-md"
              >
                Subscribe Now
              </Link>
              <Link
                to={
                  type === "daily"
                    ? "/monthly-current-affairs"
                    : "/daily-current-affairs"
                }
                className="inline-flex items-center justify-center px-6 py-3 border-2 border-white text-base font-medium rounded-md text-white hover:bg-white/10 transition-colors duration-300"
              >
                {type === "daily"
                  ? "View Monthly Compilations"
                  : "View Daily Updates"}
              </Link>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Daily Current Affairs Section */}
      {type === "daily" && (
        <>
          {/* Category Filter */}
          <section className="bg-white py-8 border-b">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="flex flex-wrap justify-center">
                {categories.map((category) => (
                  <button
                    key={category.id}
                    onClick={() => handleCategoryChange(category.id)}
                    className={`px-5 py-2 m-1 rounded-full text-sm font-medium transition-colors ${
                      activeCategory === category.id
                        ? "bg-gray-600 text-white"
                        : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                    }`}
                  >
                    {category.name}
                  </button>
                ))}
              </div>
            </div>
          </section>

          {/* Daily Affairs Grid */}
          <section className="py-16 bg-gray-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              {loading ? (
                <div className="py-16">
                  <Spinner message="Loading current affairs..." />
                </div>
              ) : error ? (
                <div className="py-16">
                  <ErrorAlert message={error} />
                </div>
              ) : (
                <>
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {dailyAffairs.map((affair, index) => (
                      <motion.div
                        key={affair._id}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, delay: index * 0.1 }}
                        className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300"
                      >
                        <div className="relative h-48">
                          <img
                            src={affair.image}
                            alt={affair.title}
                            className="w-full h-full object-cover"
                          />
                          <div className="absolute top-0 left-0 bg-gray-600 text-white px-3 py-1 text-xs font-medium">
                            {formatDate(affair.date)}
                          </div>
                        </div>
                        <div className="p-6">
                          <div className="flex flex-wrap gap-2 mb-3">
                            <span className="inline-block px-2 py-1 text-xs font-medium bg-gray-100 text-gray-800 rounded">
                              {affair.category.charAt(0).toUpperCase() +
                                affair.category.slice(1)}
                            </span>
                            {affair.prelimsRelevance && (
                              <span className="inline-block px-2 py-1 text-xs font-medium bg-green-100 text-green-800 rounded">
                                Prelims
                              </span>
                            )}
                            {affair.mainsRelevance && (
                              <span className="inline-block px-2 py-1 text-xs font-medium bg-blue-100 text-blue-800 rounded">
                                Mains
                              </span>
                            )}
                          </div>
                          <h3 className="text-xl font-bold text-gray-900 mb-2">
                            {affair.title}
                          </h3>
                          <p className="text-gray-600 mb-4 text-sm">
                            {affair.summary}
                          </p>
                          <Link
                            to={`/current-affairs/${affair._id}`}
                            className="block w-full text-center py-2 px-4 border border-gray-600 rounded-md text-gray-600 font-medium hover:bg-gray-600 hover:text-white transition-colors duration-300"
                          >
                            Read Full Analysis
                          </Link>
                        </div>
                      </motion.div>
                    ))}
                  </div>

                  {/* Show message if no affairs in selected category */}
                  {dailyAffairs.length === 0 && (
                    <div className="text-center py-16">
                      <h3 className="text-xl text-gray-600 mb-2">
                        No current affairs available in this category
                      </h3>
                      <p className="text-gray-500">
                        Please check back later or explore other categories
                      </p>
                    </div>
                  )}

                  {/* Pagination */}
                  {pagination.pages > 1 && (
                    <div className="mt-12">
                      <Pagination
                        currentPage={currentPage}
                        totalPages={pagination.pages}
                        onPageChange={handlePageChange}
                      />
                    </div>
                  )}
                </>
              )}
            </div>
          </section>
        </>
      )}

      {/* Monthly Compilations Section */}
      {type === "monthly" && (
        <>
          {/* Month and Year Filters */}
          <section className="bg-white py-8 border-b">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="flex flex-col space-y-6">
                {/* Year Selection */}
                <div>
                  <h3 className="text-gray-700 font-medium mb-3">
                    Select Year:
                  </h3>
                  <div className="flex flex-wrap gap-2">
                    {years.map((year) => (
                      <button
                        key={year}
                        onClick={() => handleYearChange(year)}
                        className={`px-5 py-2 rounded-md text-sm font-medium transition-colors ${
                          parseInt(activeYear) === year
                            ? "bg-gray-700 text-white"
                            : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                        }`}
                      >
                        {year}
                      </button>
                    ))}
                  </div>
                </div>

                {/* Month Selection */}
                <div>
                  <h3 className="text-gray-700 font-medium mb-3">
                    Select Month:
                  </h3>
                  <div className="flex flex-wrap">
                    {months.map((month) => (
                      <button
                        key={month.id}
                        onClick={() => handleMonthChange(month.id)}
                        className={`px-5 py-2 m-1 rounded-full text-sm font-medium transition-colors ${
                          activeMonth === month.id
                            ? "bg-gray-600 text-white"
                            : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                        }`}
                      >
                        {month.name}
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Monthly Compilations Grid */}
          <section className="py-16 bg-gray-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              {loading ? (
                <div className="py-16">
                  <Spinner message="Loading monthly compilations..." />
                </div>
              ) : error ? (
                <div className="py-16">
                  <ErrorAlert message={error} />
                </div>
              ) : (
                <>
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {monthlyCompilations.map((compilation, index) => (
                      <motion.div
                        key={compilation._id}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, delay: index * 0.1 }}
                        className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300"
                      >
                        <div className="relative h-48">
                          <img
                            src={compilation.image}
                            alt={compilation.title}
                            className="w-full h-full object-cover"
                          />
                        </div>
                        <div className="p-6">
                          <h3 className="text-xl font-bold text-gray-900 mb-2">
                            {compilation.title}
                          </h3>
                          <p className="text-gray-600 mb-4 text-sm">
                            {compilation.description}
                          </p>
                          <div className="flex justify-between items-center text-sm text-gray-500 mb-4">
                            <span>{compilation.pages} pages</span>
                            <span>{compilation.articles} articles</span>
                          </div>
                          <a
                            href={compilation.pdfUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="block w-full text-center py-2 px-4 border border-gray-600 rounded-md text-gray-600 font-medium hover:bg-gray-600 hover:text-white transition-colors duration-300"
                          >
                            Download PDF
                          </a>
                        </div>
                      </motion.div>
                    ))}
                  </div>

                  {/* Show message if no compilations found */}
                  {monthlyCompilations.length === 0 && (
                    <div className="text-center py-16">
                      <h3 className="text-xl text-gray-600 mb-2">
                        No monthly compilations available for this selection
                      </h3>
                      <p className="text-gray-500">
                        Please try a different month or year
                      </p>
                    </div>
                  )}

                  {/* Pagination */}
                  {pagination.pages > 1 && (
                    <div className="mt-12">
                      <Pagination
                        currentPage={currentPage}
                        totalPages={pagination.pages}
                        onPageChange={handlePageChange}
                      />
                    </div>
                  )}
                </>
              )}
            </div>
          </section>
        </>
      )}

      {/* Features Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <motion.h2
              className="text-3xl font-extrabold text-gray-900 sm:text-4xl"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              {type === "daily"
                ? "Why Our Daily Current Affairs?"
                : "Why Our Monthly Compilations?"}
            </motion.h2>
            <motion.p
              className="mt-4 max-w-2xl text-xl text-gray-600 mx-auto"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
            >
              Save time and enhance your preparation with our expert analysis
            </motion.p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="bg-gray-50 p-6 rounded-lg text-center"
            >
              <div className="inline-flex items-center justify-center h-12 w-12 rounded-full bg-gray-100 text-gray-600 mb-4">
                <svg
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                  />
                </svg>
              </div>
              <h3 className="text-lg font-medium text-gray-900 mb-2">
                UPSC-Focused Analysis
              </h3>
              <p className="text-gray-600">
                Events analyzed specifically from UPSC exam perspective,
                highlighting Prelims and Mains relevance.
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              className="bg-gray-50 p-6 rounded-lg text-center"
            >
              <div className="inline-flex items-center justify-center h-12 w-12 rounded-full bg-gray-100 text-gray-600 mb-4">
                <svg
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M13 10V3L4 14h7v7l9-11h-7z"
                  />
                </svg>
              </div>
              <h3 className="text-lg font-medium text-gray-900 mb-2">
                Subject-wise Categorization
              </h3>
              <p className="text-gray-600">
                Content organized by subjects for targeted preparation and
                efficient revision.
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="bg-gray-50 p-6 rounded-lg text-center"
            >
              <div className="inline-flex items-center justify-center h-12 w-12 rounded-full bg-gray-100 text-gray-600 mb-4">
                <svg
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                  />
                </svg>
              </div>
              <h3 className="text-lg font-medium text-gray-900 mb-2">
                Regular Updates
              </h3>
              <p className="text-gray-600">
                {type === "daily"
                  ? "Daily updates to keep you informed with the latest developments"
                  : "Comprehensive monthly compilations covering all important events"}
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.3 }}
              className="bg-gray-50 p-6 rounded-lg text-center"
            >
              <div className="inline-flex items-center justify-center h-12 w-12 rounded-full bg-gray-100 text-gray-600 mb-4">
                <svg
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                  />
                </svg>
              </div>
              <h3 className="text-lg font-medium text-gray-900 mb-2">
                Expert Analysis
              </h3>
              <p className="text-gray-600">
                Content prepared by UPSC toppers and subject experts with
                exam-specific insights.
              </p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Subscription Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <motion.h2
              className="text-3xl font-extrabold text-gray-900 sm:text-4xl"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              Current Affairs Subscription Plans
            </motion.h2>
            <motion.p
              className="mt-4 max-w-2xl text-xl text-gray-600 mx-auto"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
            >
              Choose the plan that best suits your preparation needs
            </motion.p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Basic Plan */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="bg-white rounded-lg shadow-md overflow-hidden border border-gray-200"
            >
              <div className="p-8 text-center">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">Basic</h3>
                <p className="text-gray-600 mb-6">Monthly compilations only</p>
                <div className="flex justify-center items-end mb-6">
                  <span className="text-4xl font-extrabold text-gray-900">
                    ₹2,999
                  </span>
                  <span className="text-gray-600 ml-2">/year</span>
                </div>
                <ul className="text-left space-y-4 mb-8">
                  <li className="flex items-start">
                    <svg
                      className="h-5 w-5 text-green-500 mt-0.5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span className="ml-3 text-gray-600">
                      Monthly current affairs compilations
                    </span>
                  </li>
                  <li className="flex items-start">
                    <svg
                      className="h-5 w-5 text-green-500 mt-0.5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span className="ml-3 text-gray-600">
                      Prelims & Mains relevance marked
                    </span>
                  </li>
                  <li className="flex items-start">
                    <svg
                      className="h-5 w-5 text-green-500 mt-0.5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span className="ml-3 text-gray-600">
                      Downloadable PDF format
                    </span>
                  </li>
                  <li className="flex items-start text-gray-400">
                    <svg
                      className="h-5 w-5 text-gray-400 mt-0.5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                    <span className="ml-3">Daily current affairs updates</span>
                  </li>
                  <li className="flex items-start text-gray-400">
                    <svg
                      className="h-5 w-5 text-gray-400 mt-0.5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                    <span className="ml-3">MCQs and practice questions</span>
                  </li>
                </ul>
                <Link
                  to="/register?plan=ca_basic"
                  className="block w-full bg-gray-100 hover:bg-gray-200 text-gray-900 font-medium rounded-md py-3 px-4 transition-colors duration-300"
                >
                  Subscribe Now
                </Link>
              </div>
            </motion.div>

            {/* Standard Plan */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              className="bg-white rounded-lg shadow-lg overflow-hidden border-2 border-gray-500 relative transform scale-105 z-10"
            >
              <div className="absolute top-0 inset-x-0 flex justify-center">
                <span className="inline-block px-4 py-1 rounded-b-lg text-xs font-semibold tracking-wide uppercase bg-gray-600 text-white">
                  Most Popular
                </span>
              </div>
              <div className="p-8 text-center pt-12">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">
                  Standard
                </h3>
                <p className="text-gray-600 mb-6">
                  Daily updates + Monthly compilations
                </p>
                <div className="flex justify-center items-end mb-6">
                  <span className="text-4xl font-extrabold text-gray-600">
                    ₹4,999
                  </span>
                  <span className="text-gray-600 ml-2">/year</span>
                </div>
                <ul className="text-left space-y-4 mb-8">
                  <li className="flex items-start">
                    <svg
                      className="h-5 w-5 text-green-500 mt-0.5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span className="ml-3 text-gray-600">
                      Daily current affairs updates
                    </span>
                  </li>
                  <li className="flex items-start">
                    <svg
                      className="h-5 w-5 text-green-500 mt-0.5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span className="ml-3 text-gray-600">
                      Monthly current affairs compilations
                    </span>
                  </li>
                  <li className="flex items-start">
                    <svg
                      className="h-5 w-5 text-green-500 mt-0.5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span className="ml-3 text-gray-600">
                      Subject-wise categorization
                    </span>
                  </li>
                  <li className="flex items-start">
                    <svg
                      className="h-5 w-5 text-green-500 mt-0.5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span className="ml-3 text-gray-600">
                      Prelims & Mains relevance marked
                    </span>
                  </li>
                  <li className="flex items-start text-gray-400">
                    <svg
                      className="h-5 w-5 text-gray-400 mt-0.5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                    <span className="ml-3">MCQs and practice questions</span>
                  </li>
                </ul>
                <Link
                  to="/register?plan=ca_standard"
                  className="block w-full bg-gray-600 hover:bg-gray-700 text-white font-medium rounded-md py-3 px-4 transition-colors duration-300"
                >
                  Subscribe Now
                </Link>
              </div>
            </motion.div>

            {/* Premium Plan */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="bg-white rounded-lg shadow-md overflow-hidden border border-gray-200"
            >
              <div className="p-8 text-center">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">
                  Premium
                </h3>
                <p className="text-gray-600 mb-6">
                  Complete package with practice questions
                </p>
                <div className="flex justify-center items-end mb-6">
                  <span className="text-4xl font-extrabold text-gray-900">
                    ₹6,999
                  </span>
                  <span className="text-gray-600 ml-2">/year</span>
                </div>
                <ul className="text-left space-y-4 mb-8">
                  <li className="flex items-start">
                    <svg
                      className="h-5 w-5 text-green-500 mt-0.5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span className="ml-3 text-gray-600">
                      <strong>Everything</strong> in Standard plan
                    </span>
                  </li>
                  <li className="flex items-start">
                    <svg
                      className="h-5 w-5 text-green-500 mt-0.5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span className="ml-3 text-gray-600">
                      Daily MCQs based on current affairs
                    </span>
                  </li>
                  <li className="flex items-start">
                    <svg
                      className="h-5 w-5 text-green-500 mt-0.5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span className="ml-3 text-gray-600">
                      Mains answer writing frameworks
                    </span>
                  </li>
                  <li className="flex items-start">
                    <svg
                      className="h-5 w-5 text-green-500 mt-0.5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span className="ml-3 text-gray-600">
                      Monthly current affairs webinars
                    </span>
                  </li>
                  <li className="flex items-start">
                    <svg
                      className="h-5 w-5 text-green-500 mt-0.5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span className="ml-3 text-gray-600">
                      Quarterly revision notes
                    </span>
                  </li>
                </ul>
                <Link
                  to="/register?plan=ca_premium"
                  className="block w-full bg-gray-800 hover:bg-black text-white font-medium rounded-md py-3 px-4 transition-colors duration-300"
                >
                  Subscribe Now
                </Link>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-16 bg-gradient-to-r from-gray-900 to-blue-800 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto text-center">
            <motion.h2
              className="text-3xl font-extrabold mb-6"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              Stay Ahead with Our Current Affairs
            </motion.h2>
            <motion.p
              className="text-lg text-gray-200 mb-8"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
            >
              Don't let current affairs become your weak point. Subscribe today
              and transform your UPSC preparation.
            </motion.p>
            <motion.div
              className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              <Link
                to="/register"
                className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-gray-900 bg-yellow-400 hover:bg-yellow-500 transition-colors duration-300 shadow-md"
              >
                Subscribe Now
              </Link>
              <Link
                to="/contact"
                className="inline-flex items-center justify-center px-6 py-3 border-2 border-white text-base font-medium rounded-md text-white hover:bg-white/10 transition-colors duration-300"
              >
                Contact Us
              </Link>
            </motion.div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CurrentAffairsPage;
